import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLogoutMutation } from '@/api/queries/auth';
import { clearAuthSession, getRefreshToken } from '../utils';
import { PATH } from './PATH';

/**
 * Ends the signed-in user's session: the POS lock and the admin-app sign-out.
 * Clears **only** the user session (the terminal stays enrolled), revokes the
 * refresh token on the server, and goes to `PATH.LOGIN` (seller-select). The revoke runs in
 * the background, so a network hiccup never traps the operator signed in.
 */
export const useSignOut = (): (() => void) => {
    const navigate = useNavigate();
    const { mutate: logout } = useLogoutMutation();

    return React.useCallback(() => {
        // Capture the token before clearing so the revoke still has it; clear
        // synchronously so the route guard sees a signed-out terminal at once.
        const refreshToken = getRefreshToken();
        clearAuthSession();
        if (refreshToken) {
            logout(refreshToken);
        }
        navigate(PATH.LOGIN, { replace: true });
    }, [logout, navigate]);
};
